import { api } from "../api";
import { acctPage, adminOrders, nodeCards, ordersTable, usersTable } from "../parts";
import type { Alarms, Nodes, Summary } from "../types";
import { ago, chart, dayRange, days, figures, h, link, money, num, show, size } from "../ui";

export async function overview() {
  const [sum, nodes, top, ord, alarms] = await Promise.all([
    api<Summary>(`/v1/admin/summary?days=${days()}`),
    api<Nodes>(`/v1/admin/nodes?days=${days()}`),
    acctPage({ limit: 5 }),
    adminOrders({ limit: 5 }),
    api<Alarms>("/v1/admin/alarms"),
  ]);
  if (!sum || !nodes || !top || !ord || !alarms) return;
  const n = sum.now;
  const tot = sum.days.reduce((t, d) => ({ i: t.i + d.relay_in, o: t.o + d.relay_out, s: t.s + d.sessions }), { i: 0, o: 0, s: 0 });
  const dl = dayRange(sum.from, sum.to);
  const firing = alarms.states.filter((s) => s.state === "firing");
  show(
    "Overview",
    `${sum.from} – ${sum.to} (UTC)`,
    firing.length
      ? h(
          "div",
          { class: "alarm-strip", role: "alert" },
          ...firing.map((s) => h("p", null, h("b", null, `${s.rule}${s.relay ? ` on ${s.relay}` : ""}`), ` · since ${ago(s.since)} · `, link("/alarms", "alarms →"))),
        )
      : null,
    figures([
      ["Accounts", String(n.accounts), `${n.active_accounts} active in ${days()} days`],
      ["Computers", String(n.computers), `${n.online} online now`],
      ["Phones and terminals", String(n.clients)],
      ["Relay traffic", size(tot.i + tot.o), `${size(tot.o)} to · ${size(tot.i)} from computers`],
      ["Sessions", String(tot.s), `${n.active_shares} shares active`],
      ["Revenue, 30 days", money(ord.last30d.revenue / 100), `${ord.last30d.orders} orders`],
    ]),
    h("h2", null, "Relay traffic per day"),
    chart(dl, [
      { name: "out", label: "to computers", values: new Map(sum.days.map((d) => [d.day, d.relay_out])) },
      { name: "in", label: "from computers", values: new Map(sum.days.map((d) => [d.day, d.relay_in])) },
    ], size),
    h("h2", null, "Nodes ", link("/nodes", "all nodes →")),
    nodeCards(nodes),
    h("h2", null, "Top users ", link("/users", `all ${num(top.total)} users →`)),
    usersTable(top.accounts),
    h("h2", null, "Recent orders ", link("/orders", "all orders →")),
    ordersTable(ord.orders, 5),
  );
}
